import { Controller } from 'stimulus';

export default class extends Controller {
  static values = { confirmMessage: String, defaultImage: String };

  static targets = [
    'output',
    'input',
    'filename',
    'removalCheckbox',
    'removalCheckboxWrapper',
    'removalButton',
  ];

  connect() {
    this.removalCheckboxWrapperTarget.classList.add('visually-hidden');

    const uploadedImage = this.outputTarget.src.split('/images/').pop();
    const defaultImage = this.defaultImageValue.split('/images/').pop();

    if (uploadedImage !== defaultImage) {
      this.removalButtonTarget.classList.remove('d-none');
    } else {
      this.removalButtonTarget.classList.add('d-none');
    }

    this.inputTarget.addEventListener('change', () =>
      this.showRemovalOnUpload()
    );
  }

  readURL() {
    if (this.inputTarget.files && this.inputTarget.files[0]) {
      var reader = new FileReader();

      reader.onload = () => {
        this.outputTarget.src = reader.result;
      };

      reader.readAsDataURL(this.inputTarget.files[0]);
    }
  }

  removeImage() {
    if (confirm(this.confirmMessageValue)) {
      this.removalCheckboxTarget.checked = true;
      this.filenameTarget.classList.add('visually-hidden');
      this.filenameTarget.innerHTML = '';
      this.outputTarget.src = this.defaultImageValue;
      this.inputTarget.value = '';
      this.removalButtonTarget.classList.add('d-none');
    }
  }

  showRemovalOnUpload() {
    this.removalButtonTarget.classList.remove('d-none');
  }
}
